"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useWindowListener_1 = require("./useWindowListener");
exports.useClickOutside = function (ref, callback) {
    var _callback = react_1.useMemo(function () { return callback; }, [callback]);
    var listener = react_1.useCallback(function (e) {
        var _a;
        if (!ref.current || ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
            return;
        }
        else {
            _callback(e);
        }
    }, [_callback]);
    useWindowListener_1.useWindowListener("click", listener);
};
